import React from "react";
import styled from "styled-components";
import {subduedTextColour} from "../../../../style/styleConsts";

const Count = styled.div`
    color: ${subduedTextColour};
    background-color: white;
    font-size: 9pt;
    border-radius: 12px;
    padding: 2px 8px;
    margin-top: 2px;
    margin-left: 10px;
`;

const GroupingRowCount = ({count}) => {
    return !count ? null : <Count className="t-grouping-count">{count}</Count>;
};

export default GroupingRowCount;